import { Col, Layout, Row, Typography } from "antd";
import Sider from "antd/lib/layout/Sider";
import { Content, Header } from "antd/lib/layout/layout";
import qs from "qs";
import React, { useEffect } from "react";
import { useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router";
import { autoOasisLogin, speedMateLogin } from "../../../apis/Login/apis";
import useSpecial from "../../../hooks/useSpecial";
import useUsers from "../../../hooks/useUsers";
import {
  PATH,
  autoOasisCodeQuery,
  autoOasisCodeString,
  speedMateCodeString,
  speedMateQuery,
} from "../../../routes/constants/path";
import color from "../../../theme/color";
import { OriginalLogo } from "../Icon";
import Menus from "./Menus";
import UserInfo from "./UserInfo/UserInfo";

const SpecialRepairShopLayout: React.FC = (props) => {
  const { children } = props;
  const location = useLocation();
  const { signIn, getAdminInfo } = useUsers();
  const { setSpecial } = useSpecial();
  const nav = useNavigate();
  const speedMateCode: string | undefined = qs.parse(location.search)[
    speedMateQuery
  ] as string;
  const autoOasisCode: string | undefined = qs.parse(location.search)[
    autoOasisCodeQuery
  ] as string;
  const specialCode: string | undefined =
    location.search?.includes(speedMateCodeString) ||
    location.search?.includes(autoOasisCodeString)
      ? location
        ? location?.search
            ?.split("&")
            ?.find(
              (text) =>
                text.includes(speedMateCodeString) ||
                text.includes(autoOasisCodeString)
            )
            ?.split("=")[1]
        : undefined
      : undefined;

  const singInSpeedMateMutation = useMutation(speedMateLogin, {
    onSuccess: (res) => {
      if (res.accessToken) {
        signIn(res.admin, res.accessToken);
        setSpecial(`${speedMateQuery}=${speedMateCode}`);
        nav(`${PATH.SPEED_MATE_RESERVATION + speedMateQuery}=${speedMateCode}`);
      }
    },
    onError: () => {},
  });

  const singInAutoOasisMutation = useMutation(autoOasisLogin, {
    onSuccess: (res) => {
      if (res.accessToken) {
        signIn(res.admin, res.accessToken);
        setSpecial(`${autoOasisCodeQuery}=${autoOasisCode}`);
        nav(
          `${PATH.AUTO_OASIS_RESERVATION + autoOasisCodeQuery}=${autoOasisCode}`
        );
      }
    },
    onError: () => {},
  });

  useEffect(() => {
    if (specialCode) {
      if (
        getAdminInfo()?.repairShopCode !== specialCode &&
        location.search?.includes(speedMateCodeString)
      )
        singInSpeedMateMutation.mutate({ repairShopCode: specialCode });
      if (
        getAdminInfo()?.repairShopCode !== specialCode &&
        location.search?.includes(autoOasisCodeString)
      )
        singInAutoOasisMutation.mutate({ autooasisCode: specialCode });
    }
  }, []);

  return (
    <Layout
      style={{
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
      hasSider
    >
      <Sider
        style={{
          overflow: "auto",
          height: "100vh",
          flex: "auto",
          borderRight: `1px solid ${color.gray9}`,
        }}
        width={210}
      >
        <Row
          gutter={4}
          style={{
            display: "inline-flex",
            padding: "16px 20px",
            width: "100%",
            borderBottom: `1px solid ${color.gray9}`,
          }}
          align="middle"
        >
          <Col>
            <picture style={{ display: "flex" }}>
              <OriginalLogo height={16} width={121} />
            </picture>
          </Col>
          <Col>
            <Typography.Text
              strong
              style={{
                color: color.gray2,
                fontSize: 16,
                lineHeight: "24px",
              }}
            >
              Crew
            </Typography.Text>
          </Col>
        </Row>
        <Menus />
      </Sider>
      <Layout>
        <Header
          style={{
            position: "sticky",
            right: 0,
            height: 57,
            padding: "12px 24px",
            borderBottom: `1px solid ${color.gray9}`,
            display: "inline-flex",
            justifyContent: "end",
          }}
        >
          <UserInfo />
        </Header>
        <Content
          style={{
            position: "sticky",
            overflow: "auto",
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};
export default SpecialRepairShopLayout;
